module.exports = __webpack_public_path__ + "media/defr_ceremonie.ca142be4.mp4";